<template>

<app-page>

	<core-filter-bar v-if="!is.loading && is.initialised">

		<core-filter-bar-left>

			<core-filter-summary title="Early Access" icon="flask" />

		</core-filter-bar-left>

		<core-filter-bar-right>

			<core-button text="Patreon" href="https://patreon.com/geekgroup" class="tipjar-button" icon="arrow-up-right-from-square" theme="filter" />

		</core-filter-bar-right>

	</core-filter-bar>

	<core-content-page>

		<core-content-wrapper :loading="is.loading && !is.initialised">

			<div class="items" :class="{'is-hidden': is.loading && !is.initialised}">

				<div class="item is-intro" key="intro">

					<div class="item-text">

						<p>Try out new GeekGroup features before they’re released to everyone. Patreons get an exclusive chance to explore new featres, preview what’s coming next, and help shape how features evolve.</p>
						
					</div>

				</div>

				<div class="item" v-for="item in data.items" :key="item.id">

					<div class="item-image" v-bgimage="item.image" v-if="item.status === 1" />

					<div class="item-coming" v-if="item.status === 2">

						{{ item.url | 'Coming soon' }}	

					</div>

					<div class="item-text">

						<h2>{{ item.name }}</h2>

						<div class="item-date" v-if="item.status === 1">Until {{ item.date.live | formatDate('Do MMMM YYYY') }}</div>

						<p v-html="item.description" />

						<core-button text="Read more" class="item-button" v-on:click="onMoreClick(item.url)" v-if="item.status === 1" />

					</div>

				</div>

			</div>

		</core-content-wrapper>

	</core-content-page>
		
</app-page>

</template>

<script>

import Vue from 'vue'

export default {

	data: function() {
	
		return {

			data: {},

			is: {
				initialised: false,
				loading: true
			}

		}
	
	},

	created: function() {

		this.load()

	},

	methods: {

		onMoreClick: function(url) {

			window.open(url)

		},
	
		load: function() {
		
			this.$api.get('community/access').then(function(json) {

				Vue.set(this, 'data', json)

				this.is.initialised = true

				this.is.loading = false
			
			}.bind(this))
		
		}

	}

}

</script>

<style scoped>

.items {
	display: grid;
	grid-template-columns: 1fr 1fr 1fr;
	grid-template-rows: auto;
	grid-gap: 40px;
    align-items: start;
}

.is-smaller .items {
	grid-gap: 20px;
}

.is-tablet .items {
	grid-gap: 20px;
	grid-template-columns: 1fr 1fr;
}

.is-mobile .items {
	grid-template-columns: 1fr;
	grid-gap: 20px;
	padding: 10px;
}

.items.is-hidden {
	opacity: 0;
}

.item-image {
	height: 160px;
	background-size: contain;
	background-position: 50% 50%;
	background-repeat: no-repeat;
	background-color: #4881bb;
	border-radius: 4px 4px 0px 0px;
	border: 1px solid #ddd;
    background-size: cover;
}

.item-coming {
	height: 160px;
	background-size: contain;
	background-position: 50% 50%;
	background-repeat: no-repeat;
	background-color: #4881bb;
	border-radius: 4px 4px 0px 0px;
	border: 1px solid #ddd;
    background-size: cover;
	text-align: center;
	line-height: 160px;
	font-size: 32px;
	font-weight: 500;
	color: #fff;
}

.item-text {
	padding: 20px;
	border: 1px solid #ddd;
	border-top: 0px;
	background-color: #fff;
	border-radius: 0px 0px 4px 4px;
}

.is-mobile .item-text {
	padding: 10px;
}

.item.is-intro {
    grid-column: span 3;
}

.is-mobile .item.is-intro {
    grid-column: span 1;
}

.item.is-intro .item-text {
	border-top: 1px solid #ddd;
	border-radius: 4px;
	height: 100%;
}

.is-mobile .item.is-intro .item-text {
	border: 0px;
	padding: 10px 0px 0px 0px;
}

.item-text h2 {
	font-size: 20px;
	margin-bottom: 4px;
}

.item.is-intro .item-text h2 {
	margin-bottom: 20px;
}

.item-text p {
	font-size: 16px;
	line-height: 20px;
	color: #222;
	margin-bottom: 20px;
}

.item-text p:last-child {
	margin-bottom: 0px;
}

.item-date {
	font-size: 14px;
	line-height: 14px;
	font-weight: 400;
	color: #999;
	margin-bottom: 10px;
}

.item-button {
	width: 100%;
}

.tipjar-button {
	line-height: 40px;
	font-weight: 700;
	display: flex!important;
	text-align: left!important;
	background-color: #082534!important;
}

.tipjar-button.is-connect {
	background-color: #48bb6a!important;
	margin-top: 5px;
}

.tipjar-button.is-secondary {
	background-color: #4881bb!important;
	margin-top: 5px;
}

</style>